import styled from 'styled-components';

import { BreakPoint } from '@makemydeal/dr-activities-common';

export const StyledVehicleContainer = styled.div`
    display: flex;
    align-items: start;
    gap: ${({ theme }) => theme.tokens.BaseSpace40};
`;

export const StyledVehicleImage = styled.div`
    flex-shrink: 0;
    img {
        width: 9.5rem;
        max-height: 5.25rem;
        object-fit: cover;
        border-radius: 0.3rem;
        overflow-clip-margin: unset;
    }

    @media (max-width: ${BreakPoint.PHONE}) {
        img {
            width: 10.5rem;
            max-height: 11rem;
            height: 8.5rem;
        }
    }
`;

export const StyledVehicleSubContainer = styled.div`
    width: 100%;
    button {
        span {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 100%;
            text-transform: capitalize;
        }
    }
`;

export const StyledVehicleInfo = styled.div`
    margin-top: ${({ theme }) => theme.tokens.BaseSpace25};
    display: flex;
    gap: '0.375rem 1.143rem';
    flex-wrap: wrap;
    align-items: center;
`;

export const VehicleInfoCardBaseSeparator = styled.span`
    margin-right: ${({ theme }) => theme.tokens.BaseSpace25};
    margin-left: ${({ theme }) => theme.tokens.BaseSpace25};
`;
